const allowedTags = new Set(['B', 'STRONG', 'I', 'EM', 'U', 'P', 'BR', 'DIV', 'SPAN']);

export const sanitizeNoteHtml = value => {
  if (typeof window === 'undefined') return String(value || '');
  const documentValue = new DOMParser().parseFromString(String(value || ''), 'text/html');
  [...documentValue.body.querySelectorAll('*')].forEach(element => {
    if (!allowedTags.has(element.tagName)) {
      element.replaceWith(documentValue.createTextNode(element.textContent || ''));
      return;
    }
    [...element.attributes].forEach(attribute => {
      if (attribute.name !== 'style' || !/^background-color\s*:/i.test(attribute.value)) element.removeAttribute(attribute.name);
    });
  });
  return documentValue.body.innerHTML;
};
